import { useEffect, useState } from 'react';
import { SchemaHolder } from './schema';
import { QueryParameters, FilterSummaryItem } from './types';

export function useFilterSummary<StaticProps, SearchQuery, Parameters extends QueryParameters>(props: {
  staticProps: StaticProps;
  parameters: Parameters;
  defaultParameters: Parameters;
  schema: SchemaHolder<StaticProps, SearchQuery, Parameters>;
}) {
  const [state, setState] = useState<FilterSummaryItem<Parameters, keyof Parameters>[]>([]);

  useEffect(() => {
    setState((currentFilterSummary) => {
      const newUids: string[] = [];
      const existingKeys = currentFilterSummary.map((fs) => fs.key);
      let summaries: FilterSummaryItem<Parameters, keyof Parameters>[] = [...currentFilterSummary];
      props.schema.parameters.forEach((parameter) => {
        if (!parameter.getSummaryItems) return;
        const value = parameter.getValue({ staticProps: props.staticProps, parameters: props.parameters });
        const defaultValue = parameter.getDefaultValue({ defaultParameters: props.defaultParameters });
        const result = parameter.getSummaryItems({
          value,
          defaultValue,
          staticProps: props.staticProps,
          parameters: props.parameters,
        });
        if (!result || result.length === 0) return;

        result.forEach((nfs) => newUids.push(nfs.key));
        summaries = [...summaries, ...result.filter((nfs) => !existingKeys.includes(nfs.key))];
      });
      return summaries.filter((efs) => newUids.includes(efs.key));
    });
  }, [props.schema.parameters, props.staticProps, props.parameters, props.defaultParameters]);

  return { filterSummaries: state };
}
